import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IConsentMasterData_DocLibrary, IConsentNameMasterData_DocLib, IConsentNameMasterData_DocLibAll } from 'src/app/models/IDocumentLibrary';
import { configuration } from 'src/environments/environment';
import { Observable } from 'rxjs/Rx';
import { ILocationDetails_ID_DocLibrary, IPatientDetails_DocLibrary, ISignatures, ISignaturesNew } from 'src/app/models/IDocument';
import { IDocLibPatientForms, IDocLibPatientForms_Signatures } from 'src/app/models/IPatientForms';



@Injectable({
  providedIn: 'root'
})
export class DocumentLibraryService {

  constructor(private http: HttpClient) { }

  //Get consent details

  //   getConsentMasterDetails(ConsentMasterID:number): Observable<IConsentMasterData_DocLibrary[]> {
  //    return this.http.get<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/ConsentMasterDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&ConsentMasterID=${ConsentMasterID.toString()}`);
  //  }

  getConsentMasterDetails(ConsentMasterID: number): Observable<IConsentMasterData_DocLibrary[]> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      ConsentMasterID: ConsentMasterID.toString(),
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetConsentMasterDetails'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  //  getConsentMasterDetails_TargetLocid(targetLocID:number): Observable<IConsentNameMasterData_DocLib[]> {
  //   return this.http.get<IConsentNameMasterData_DocLib[]>(`${configuration.clinicapiUrl + 'Master/ConsentMasterDetails_TargetLocID'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&targetLocID=${targetLocID.toString()}`);
  // }

  getConsentMasterDetails_TargetLocid(targetLocID: number): Observable<IConsentNameMasterData_DocLib[]> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      targetLocID: targetLocID.toString(),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IConsentNameMasterData_DocLib[]>(`${configuration.clinicapiUrl + 'Master/ConsentMasterDetails_TargetLocID'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  // getAllConsentMasterDetails_TargetLocid(targetLocID:number): Observable<IConsentNameMasterData_DocLibAll[]> {
  //   return this.http.get<IConsentNameMasterData_DocLibAll[]>(`${configuration.clinicapiUrl + 'Master/AllConsentMasterDetails_TargetLocID'}?LocationID=${Number(sessionStorage.getItem("LocationId"))}&&facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&targetLocID=${targetLocID.toString()}`);
  // }
  getAllConsentMasterDetails_TargetLocid(targetLocID: number): Observable<IConsentNameMasterData_DocLibAll[]> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      targetLocID: targetLocID.toString(),
      LocationID: Number(sessionStorage.getItem("LocationId")),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IConsentNameMasterData_DocLibAll[]>(`${configuration.clinicapiUrl + 'Master/AllConsentMasterDetails_TargetLocID'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }



  // docLibGetSignatureList(ConsentMasterID:number): Observable<ISignaturesNew[]> {
  //   return this.http.get<ISignaturesNew[]>(`${configuration.clinicapiUrl + 'Master/docLibGetSignatureList'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&ConsentMasterID=${ConsentMasterID.toString()}`);
  // }
  docLibGetSignatureList(ConsentMasterID: number): Observable<ISignaturesNew[]> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      ConsentMasterID: ConsentMasterID.toString(),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<ISignaturesNew[]>(`${configuration.clinicapiUrl + 'Master/docLibGetSignatureList'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  /*docLibGetMasterData(): Observable<DocumentLibrary_Onload[]> {
    return this.http.get<DocumentLibrary_Onload[]>(`${configuration.clinicapiUrl + 'Master/docLibGetMasterData'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  
  getEMRConsentDetails_FacilityID(ConsentMasterID:number): Observable<IConsentMasterData_DocLibrary[]> {
    return this.http.get<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/ConsentMasterDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&ConsentMasterID=${ConsentMasterID.toString()}`);
  }*/

  /*getEMRConsentDetails_ConsentID(PatientConsentID:number): Observable<IConsentMasterData_DocLibrary[]> {
    return this.http.get<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetEMRPatientConsentDetailsID'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&PatientConsentID=${PatientConsentID.toString()}`);
  }*/
  // getEMRConsentDetails_ConsentID(PatientConsentID:number): Observable<IDocLibPatientForms[]> {
  //   return this.http.get<IDocLibPatientForms[]>(`${configuration.clinicapiUrl + 'Master/GetEMRPatientConsentDetailsID'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&PatientConsentID=${PatientConsentID.toString()}`);
  // }
  getEMRConsentDetails_ConsentID(PatientConsentID: number): Observable<IDocLibPatientForms[]> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      PatientConsentID: PatientConsentID.toString(),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IDocLibPatientForms[]>(`${configuration.clinicapiUrl + 'Master/GetEMRPatientConsentDetailsID'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetEMRConsentSignedList(EMRConsentID: number): Observable<IDocLibPatientForms_Signatures[]> {
    return this.http.get<IDocLibPatientForms_Signatures[]>(`${configuration.clinicapiUrl + 'Master/GetConsentSignedDetails'}?EMRConsentformID=${EMRConsentID}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  /*
  getEMRConsentDetails_FacilityID(ConsentMasterID:number): Observable<IConsentMasterData_DocLibrary[]> {
    return this.http.get<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/ConsentMasterDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&ConsentMasterID=${ConsentMasterID.toString()}`);
  }*/



  //Add Master consent Details
  addConsentMasterDetails(consentInfo: IConsentMasterData_DocLibrary): Observable<string> {
    // const postdata={
    //   consentInfo:consentInfo,

    //  }

    const posteddata = {
      inputdata: JSON.stringify(consentInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/ConsentMasterDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //Add EMR consent Details
  InsertEMRConsentDetails(consentInfo: IDocLibPatientForms): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/InsertEMRConsentDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}`, consentInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  //ADD EMR Consent Signatures
  InsertEMRConsentSignatureDetails(consentInfo: IDocLibPatientForms_Signatures): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/InsertEMRConsentSignatureDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}`, consentInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }




  getPatientdetailsByIDDoclib(PatientId: number): Observable<IPatientDetails_DocLibrary[]> {
    return this.http.get<IPatientDetails_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/DocLIBPatientDetails_ID'}?PatientId=${PatientId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getLocationDetailsByIDDocLib(LocationID: number): Observable<ILocationDetails_ID_DocLibrary[]> {
    return this.http.get<ILocationDetails_ID_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/DocLIBLocationDetails_ID'}?LocationID=${LocationID}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // GetConsentDetails(ConsentMasterID:number=0): Observable<IConsentMasterData_DocLibrary[]> {
  //   return this.http.get<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetConsentDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&ConsentMasterID=${ConsentMasterID.toString()}`);
  // }

  GetConsentDetails(ConsentMasterID: number = 0): Observable<IConsentMasterData_DocLibrary[]> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      ConsentMasterID: ConsentMasterID.toString(),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetConsentDetails'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  // GetAllConsentDetails(ConsentMasterID:number=0): Observable<IConsentMasterData_DocLibrary[]> {
  //   return this.http.get<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetALLConsentDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&ConsentMasterID=${ConsentMasterID.toString()}`);
  // }

  // UpdateStatus(ConsentMasterID:number,Active:boolean): Observable<string> {
  //    return this.http.put<string>(`${configuration.clinicapiUrl + 'Master/ConsentDetailsStatusUpdate'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&isActive=${Active.toString()}&&ConsentMasterID=${ConsentMasterID.toString()}`, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  GetAllConsentDetails(ConsentMasterID: number = 0): Observable<IConsentMasterData_DocLibrary[]> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      ConsentMasterID: ConsentMasterID.toString(),
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetALLConsentDetails'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  UpdateStatus(ConsentMasterID: number, Active: boolean): Observable<string> {
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      isActive: Active,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      ConsentMasterID: ConsentMasterID
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/ConsentDetailsStatusUpdate'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }




  DocumentLibrary_SendMail(reportId: number, DocLibId: number, patientId: number, ConsentFormName: string, facilityID: number): Observable<void> {
    const DocLibSendMail_PenRequest = {
      PatientID: patientId,
      LocationID: Number(sessionStorage.getItem("LocationId")),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      reportId: reportId,
      DocLibId: DocLibId,
      ConsentFormName: ConsentFormName,
      facilityID: facilityID
    }
    return this.http.post<void>
      (`${configuration.apiUrl + 'Document/DocumentLibrary_SendMail'}`, DocLibSendMail_PenRequest, {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }


  //GetConsentDetailsData int facilityId, string userId, int ConsentMasterID,int PatientID,string EncounterID
  //  getConsentMasterDetailsData(ConsentMasterID:number,PatientID:number,EncounterID:string): Observable<IConsentMasterData_DocLibrary[]> {
  //   return this.http.get<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetConsentDetailsData'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&ConsentMasterID=${ConsentMasterID.toString()}&&PatientID=${PatientID.toString()}&&EncounterID=${EncounterID.toString()}&&locationid=${Number(sessionStorage.getItem("LocationId"))}`);
  // }

  getConsentMasterDetailsData(ConsentMasterID: number, PatientID: number, EncounterID: string, DocLibTargetLocID: number): Observable<IConsentMasterData_DocLibrary[]> {

    var appid = sessionStorage.getItem("appId") ? sessionStorage.getItem("appId").toString() : ''
    appid = EncounterID.length > 0 ? '' : appid;
    const postdata = {
      facilityId: sessionStorage.getItem("FacilityId"),
      ConsentMasterID: ConsentMasterID.toString(),
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      EncounterID: EncounterID.toString(),
      PatientID: PatientID.toString(),
      locationid: Number(sessionStorage.getItem("LocationId")),
      DocLibTargetLocID: DocLibTargetLocID,
      Appointmentid: appid
    }


    return this.http.post<IConsentMasterData_DocLibrary[]>(`${configuration.clinicapiUrl + 'Master/GetConsentDetailsData'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

}




